import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-usa-banner',
	templateUrl: './usa-banner.component.html',
	imports: [CommonModule],
})
export class UsaBannerComponent implements OnInit {
	detailsShown: boolean = false;

	constructor() {}

	ngOnInit() {}

	showDetails() {
		this.detailsShown = !this.detailsShown;
	}
}
